import client from "./client";

export const fileUpload = (file) => {
    const url = '/api/upload';
    const formData = new FormData();
    formData.append('file', file.file);
    formData.append('targetName', file.targetName);
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };

    return  client.post(url, formData, config)
};

export const rentFileUpload = (file) => {
    const url = '/api/uploadfile';
    const formData = new FormData();
    formData.append('file', file.file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };

    return  client.post(url, formData, config)
};

export const kognrFileUpload = ({data}) => {
    const url = '/api/kognrFileUpload';

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };

    for (let key of data.keys()) {
        console.log(key);
    }

// FormData의 value 확인
    for (let value of data.values()) {
        console.log(value);
    }

    return client.post(url, data, config)
};

export const fileUploadAndCheck = (file) => {
    const url = '/api/uploadAndCheck';
    const formData = new FormData();
    formData.append('file', file.file);
    formData.append('stdYear', file.stdYear);
    formData.append('targetName', file.targetName);
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };

    return  client.post(url, formData, config)
}

/**
 * Azure Storage Blob Upload
 * @param file blob file
 * @param opts 파일 부가 정보
 */
export const fileUploadToAzureStorage = async (file, opts) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("attcFileBizGcd", opts.attcFileBizGcd || "");
    formData.append("kognrFileGcd", opts.kognrFileGcd || "");
    formData.append("stdYear", opts.stdYear || "");
    formData.append("admnNo", opts.admnNo || "");
    formData.append("calcGcd", "");
    formData.append("mediaFileGcd", "");

    return client.post("/storage/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};

/**
 * delete blob file
 * @param attcFileBizGcd 컨테이너명
 * @param fileUuid 파일명
 * @param bizFileSeq 업무 파일 일련번호 - public 스토리지일 경우 공백
 * @param fileSeq 파일 연번 - public 스토리지일 경우 공백
 */
export const deleteBlobFile = (
    fileUuid,
    bizFileSeq,
    fileSeq,
    attcFileBizGcd = "hc056002"
) => client.post("/storage/delete", {
    bizFileSeq,
    fileSeq,
    fileUuid,
    attcFileBizGcd
});


export const findFilesByFileGcd = async (admnNo, stdYear) => client.get("/kognr/files", {
    cache: false,
    params: {
        admnNo,
        stdYear
    }
});

export const findBoardFiles = async (admnNo, stdYear) => client.get("/kognr/boardFiles", {
    cache: false,
    params: {
        admnNo,
        stdYear
    }
})
